import fetchLoyaltyAccount from 'actions/loyalty/fetchLoyaltyAccount'
import { setHeadlessMode } from 'actions/SystemActions'
import AuthRouteElement from 'components/App/Routes/AuthRouteElement'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import RedirectWithStatus from 'components/Common/RedirectWithStatus'
import useQueryParams from 'hooks/useQueryParams'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { LOYALTY_LANDING_PAGE } from 'loyalty/constants/loyaltyRoutes'
import getLoyaltyIsInfiniteAccountTier from 'loyalty/selectors/getLoyaltyIsInfiniteAccountTier'
import { useEffect } from 'react'
import type { ReactNode } from 'react'

interface Props {
  children?: ReactNode
  element?: ReactNode
  path: string
  showPopup?: boolean
  loader?: ReactNode
  accountAccessModalInitialMode?: App.UiAccountModalMode
}

function LoyaltyInfiniteMemberRoute(props: Props) {
  const queryParams = useQueryParams()
  const {
    accountAccessModalInitialMode,
    children,
    element,
    loader,
    path,
    showPopup,
  } = props
  const accountAccessModalDismissable = queryParams.get('login_method') === 'phone' ? false : undefined

  return (
    <AuthRouteElement
      accountAccessModalDismissable={accountAccessModalDismissable}
      accountAccessModalInitialMode={accountAccessModalInitialMode}
      loader={loader}
      path={path}
      showPopup={showPopup}
    >
      <InfiniteMemberGuard>
        {element}
        {children}
      </InfiniteMemberGuard>
    </AuthRouteElement>
  )
}

function InfiniteMemberGuard(props: { children: ReactNode }) {
  const dispatch = useAppDispatch()
  const loyaltyAccount = useAppSelector(state => state.loyalty.account)
  const regionCode = useAppSelector(state => state.geo.currentRegionCode)
  const isInfiniteLoyaltyMember = useAppSelector(state => getLoyaltyIsInfiniteAccountTier(state))

  useEffect(() => {
    if (loyaltyAccount.initial && !loyaltyAccount.fetching) {
      dispatch(fetchLoyaltyAccount())
    }
  }, [dispatch, loyaltyAccount.fetching, loyaltyAccount.initial])

  useEffect(() => {
    if (!loyaltyAccount.initial && !loyaltyAccount.fetching && !isInfiniteLoyaltyMember) {
      dispatch(setHeadlessMode(false))
    }
  }, [dispatch, isInfiniteLoyaltyMember, loyaltyAccount.fetching, loyaltyAccount.initial])

  if (loyaltyAccount.initial || loyaltyAccount.fetching) {
    return <LoadingIndicator />
  }

  if (!isInfiniteLoyaltyMember) {
    return <RedirectWithStatus
      code={302}
      to={`/${regionCode.toLowerCase()}/${LOYALTY_LANDING_PAGE}`}
      withSearchAndHash={false}
    />
  }

  return <>{props.children}</>
}

export default LoyaltyInfiniteMemberRoute
